import axios from './axiosConfig';
import { CookieNames, getCookie } from '../helpers/cookie.helper';

export const updateSMTPDetailSystemParams = async (data) => {
    try {
        const response = await axios.post(`/api/CompanyMaster/UpdateSMTPDetailSystemParams`, data, {
            params: {
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getSMTPDetailSystemParams = async (companyId) => {
    try {
        const response = await axios.get(`/api/CompanyMaster/GetSMTPDetailSystemParams`, {
            params: {
                Id: companyId,
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}